import * as React from 'react';
import {
	ValidationRuleFragment,
	TravellerFieldEnum,
	SubsidyType,
	TravellerProfileLightFragment
} from '@websky/graphql';
import { NationalityKeyLabelMap } from '@entities/passengers';

export enum InputType {
	Text = 'text',
	Date = 'date',
	Select = 'select',
	Switch = 'radio',
	Autocomplete = 'autocomplete',
	Phone = 'phone',
	Checkbox = 'checkbox',
	Nationality = 'nationality'
}

export interface PassengerFieldOption {
	key: string;
	value: string;
	icon?: React.ReactNode;
	disabled?: boolean;
}

export enum AdditionalTravellerFieldEnum {
	OrganizationName = 'OrganizationName',
	AccompanyingCheck = 'AccompanyingCheck',
	PersonnelNumber = 'PersonnelNumber',
	ChangeTravellerFile = 'ChangeTravellerFile',
	Disability = 'Disability',
	Subsidy = 'Subsidy'
}

export interface SubsidyOption extends PassengerFieldOption {
	label: string;
	type: SubsidyType;
	additionalFields?: CommonField[];
}

export interface SubsidyField extends CommonField {
	input: InputType.Select;
	options: SubsidyOption[];
}

export interface MaxBirthDates {
	min: Date;
	max: Date;
}

export interface NameField extends Omit<CommonField, 'type'> {
	type: TravellerFieldEnum.LastName | TravellerFieldEnum.FirstName;
	nationalities?: NationalityKeyLabelMap;
	maxBirthDates: MaxBirthDates;
	travellerProfiles?: TravellerProfileLightFragment[];
}

export interface CommonField {
	readonly?: boolean;
	isEditable?: boolean;
	name: string;
	type: TravellerFieldEnum | AdditionalTravellerFieldEnum;
	input: InputType;
	placeholder?: string;
	options?: PassengerFieldOption[];
	defaultValue?: string;
	validations?: ValidationRuleFragment[];
	icon?: React.ReactNode;
	isSubsidyAdditionalField?: boolean;
}

export type PassengerField = SubsidyField | CommonField | NameField;

export interface FieldsMap {
	[name: string]: PassengerField;
}

export enum FieldGroupType {
	Identity = 'identity',
	Citizenship = 'citizenship',
	Loyalty = 'loyalty',
	Other = 'other',
	Contacts = 'contacts'
}

export interface FieldGroups {
	type: FieldGroupType;
	fields: PassengerField[];
}

export interface FieldGroupsMap {
	[type: string]: PassengerField[];
}
